import { PageIdentityEnum } from "../../../../enums/page-identity.enum";
import { MediaProviderTypeEnum } from "../../../../enums/media/media-provider-type.enum";
import { DISPLAY_FAILED_STATUS_VALUES } from "../../../../enums/display/display-summarized-status.enum";
import { ITableFilterSetState } from "../../interfaces/table-filter-set.sate";

// Media error log — one single-select chip per provider TYPE, for all seven types.
// Filters the log on providerType (a fixed enum, so these are stable). Chip labels fall back
// to set.name (the type name, matching ENUMS.source); the value is the enum's numeric id.
// Order follows the "Add provider" picker (MEDIA_PROVIDER_TYPES).
export const MEDIA_ERROR_LOG_PROVIDER_FILTER_SETS: ITableFilterSetState[] = [
  { id: 30, name: 'SFTP', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.SFTP), apply: true }] },
  { id: 31, name: 'FTP', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.FTP), apply: true }] },
  { id: 32, name: 'FINFO', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.FINFO), apply: true }] },
  { id: 33, name: 'Perfion', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.Perfion), apply: true }] },
  { id: 34, name: 'Qbank', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.Qbank), apply: true }] },
  { id: 35, name: 'NewI.It', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.NewIIt), apply: true }] },
  { id: 36, name: 'GeneralUrl', active: false, group: 'Provider', groupedFilterIds: [30, 31, 32, 33, 34, 35, 36], filters: [{ fieldName: 'providerType', operator: 'eq', value: String(MediaProviderTypeEnum.GeneralUrl), apply: true }] },
];

export const DEFAULT_FILTER_SETS: Partial<Record<PageIdentityEnum, ITableFilterSetState[]>> = {
  [PageIdentityEnum.DisplayList]: [
    {
      id: 6,
      name: 'OKEY',
      active: false,
      group: 'Status',
      groupedFilterIds: [6, 2, 3],
      filters: [
        {
          fieldName: 'summarizedStatus',
          operator: 'co',
          value: '10',
          apply: true
        }
      ]
    },
    {
      id: 2,
      name: 'FAILED',
      active: false,
      group: 'Status',
      groupedFilterIds: [6, 2, 3],
      filters: [
        {
          fieldName: 'summarizedStatus',
          operator: 'co',
          value: DISPLAY_FAILED_STATUS_VALUES.join(', '),
          apply: true
        }
      ]
    },
    {
      id: 3,
      name: 'QUEUED',
      active: false,
      group: 'Status',
      groupedFilterIds: [6, 2, 3],
      filters: [
        {
          fieldName: 'queued',
          operator: 'eq',
          value: 'true',
          apply: true
        }
      ]
    },
    {
      id: 4,
      name: 'PRODUCT',
      active: false,
      group: 'Product',
      groupedFilterIds: [4, 5],
      filters: [
        {
          fieldName: 'attachedProducts.productNumber',
          operator: 'nem',
          value: '',
          apply: true
        }
      ]
    },
    {
      id: 5,
      name: 'NO_PRODUCT',
      active: false,
      group: 'Product',
      groupedFilterIds: [4, 5],
      filters: [
        {
          fieldName: 'attachedProducts.productNumber',
          operator: 'em',
          value: '',
          apply: true
        }
      ]
    },
    {
      id: 1,
      name: 'LOW_BATTERY',
      active: false,
      group: 'Other',
      filters: [
        {
          fieldName: 'isLowBattery',
          operator: 'eq',
          value: 'true',
          apply: true
        }
      ]
    },
    {
      id: 7,
      name: 'LOW_TEMP',
      active: false,
      group: 'Other',
      filters: [
        {
          fieldName: 'isLowTemperature',
          operator: 'eq',
          value: 'true',
          apply: true
        }
      ]
    },
  ],
  [PageIdentityEnum.ProductList]: [
    {
      id: 8,
      name: 'IN_USE',
      active: false,
      group: 'Status',
      groupedFilterIds: [8, 9, 10],
      filters: [
        {
          fieldName: 'productStatus',
          operator: 'co',
          value: '1',
          apply: true
        }
      ]
    },
    {
      id: 9,
      name: 'NOT_IN_USE',
      active: false,
      group: 'Status',
      groupedFilterIds: [8, 9, 10],
      filters: [
        {
          fieldName: 'productStatus',
          operator: 'co',
          value: '2',
          apply: true
        }
      ]
    },
    {
      id: 10,
      name: 'ARCHIVED',
      active: false,
      group: 'Status',
      groupedFilterIds: [8, 9, 10],
      filters: [
        {
          fieldName: 'productStatus',
          operator: 'co',
          value: '0',
          apply: true
        }
      ]
    },
    {
      id: 11,
      name: 'UPDATED_DAY',
      active: false,
      filters: [
        {
          id: 'to',
          fieldName: 'lastUpdated',
          operator: 'lt',
          value: ServerFormatDate(new Date()),
          apply: true
        },
        {
          id: 'from',
          fieldName: 'lastUpdated',
          operator: 'gt',
          value: ServerFormatDate(new Date(new Date().setDate(new Date().getDate() - 1))),
          apply: true
        }
      ]
    },
  ],
  [PageIdentityEnum.CommunicatorList]: [
    {
      id: 12,
      name: 'ONLINE',
      active: false,
      group: 'Network',
      groupedFilterIds: [12, 13],
      filters: [
        {
          fieldName: 'connectionStatus',
          operator: 'co',
          value: '1, 2, 3',
          apply: true
        },
      ]
    },
     {
      id: 13,
      name: 'OFFLINE',
      active: false,
      group: 'Network',
      groupedFilterIds: [12, 13],
      filters: [
        {
          fieldName: 'connectionStatus',
          operator: 'co',
          value: '-1, 0, 4',
          apply: true
        },
      ]
    }
  ],
  [PageIdentityEnum.DesignPackageList]: [
    {
      id: 17,
      name: 'LOCAL',
      active: false,
      group: 'Scope',
      groupedFilterIds: [17, 18],
      filters: [
        {
          fieldName: 'scope',
          operator: 'eq',
          value: '0',
          apply: true
        }
      ]
    },
    {
      id: 18,
      name: 'GROUP',
      active: false,
      group: 'Scope',
      groupedFilterIds: [17, 18],
      filters: [
        {
          fieldName: 'scope',
          operator: 'eq',
          value: '1',
          apply: true
        }
      ]
    },
  {
  id: 19,
  name: 'In Use',
  active: false,
  filters: [{ fieldName: 'isInUse', operator: 'eq', value: 'true', apply: true }]
}
  ],
  // Media List (handover §7): Source (Uploaded/Synced) and Scope (Local/Group).
  // Scope is identical in shape to the Designs list above.
  [PageIdentityEnum.MediaImageLibraryList]: [
    // Source: "Manual upload" is the single value 0; "Synced" is every provider value (1..7).
    { id: 20, name: 'Manual upload', active: false, group: 'Source', groupedFilterIds: [20, 21], filters: [{ fieldName: 'source', operator: 'co', value: '0', apply: true }] },
    { id: 21, name: 'Synced', active: false, group: 'Source', groupedFilterIds: [20, 21], filters: [{ fieldName: 'source', operator: 'co', value: '1, 2, 3, 4, 5, 6, 7', apply: true }] },
    { id: 22, name: 'Local', active: false, group: 'Scope', groupedFilterIds: [22, 23], filters: [{ fieldName: 'scope', operator: 'eq', value: '0', apply: true }] },
    { id: 23, name: 'Group', active: false, group: 'Scope', groupedFilterIds: [22, 23], filters: [{ fieldName: 'scope', operator: 'eq', value: '1', apply: true }] },
    // Usage: Used (usages > 0) vs Unused (usages = 0). Mutually exclusive single-select group.
    { id: 24, name: 'Used', active: false, group: 'Usage', groupedFilterIds: [24, 25], filters: [{ fieldName: 'usages', operator: 'gt', value: '0', apply: true }] },
    { id: 25, name: 'Unused', active: false, group: 'Usage', groupedFilterIds: [24, 25], filters: [{ fieldName: 'usages', operator: 'lt', value: '1', apply: true }] },
  ],
  [PageIdentityEnum.MediaErrorLog]: MEDIA_ERROR_LOG_PROVIDER_FILTER_SETS,
  // Video library (standalone Vision4K feature): Stream (Stream/File — a plain boolean) and Scope
  // (Local/Group, identical in shape to the image list above).
  [PageIdentityEnum.MediaVideoLibraryList]: [
    { id: 26, name: 'Stream', active: false, group: 'Type', groupedFilterIds: [26, 27], filters: [{ fieldName: 'isStream', operator: 'eq', value: 'true', apply: true }] },
    { id: 27, name: 'File', active: false, group: 'Type', groupedFilterIds: [26, 27], filters: [{ fieldName: 'isStream', operator: 'eq', value: 'false', apply: true }] },
    { id: 28, name: 'Local', active: false, group: 'Scope', groupedFilterIds: [28, 29], filters: [{ fieldName: 'scope', operator: 'eq', value: '0', apply: true }] },
    { id: 29, name: 'Group', active: false, group: 'Scope', groupedFilterIds: [28, 29], filters: [{ fieldName: 'scope', operator: 'eq', value: '1', apply: true }] },
  ],
  };

function ServerFormatDate(date: Date) {
  return [
    String(date.getDate()).padStart(2, '0'),
    String(date.getMonth() + 1).padStart(2, '0'),
    date.getFullYear()
  ].join('-');
}